import type { ReactElement } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/common-components/filters-panel/constants";

import type { IAppsAndroidCategoryFilter } from "../../../types/androidFiltersDto";
import type { IAppsAndroidCategoryDescriptionDto } from "../../../types/descriptionDto";

const AppAndroidCategoryFilterResult = ({
    value,
    onFilterUpdate,
    isExpanded,
}: IFilterViewBaseModelProps<IAppsAndroidCategoryFilter, IAppsAndroidCategoryDescriptionDto>): ReactElement | null => {
    const categoryValues = (value as IAppsAndroidCategoryFilter)?.values || [];

    const chipItems = categoryValues.map((item: string) => ({ id: item, text: item }));
    const handleRemoveValue = (valueItem: string) => {
        const filterData = { values: categoryValues.filter((item: string) => item !== valueItem) };
        onFilterUpdate(filterData.values.length > 0 ? filterData : undefined);
    };

    if (categoryValues.length === 0) {
        return null;
    }

    return (
        <Flex flexWrap="wrap">
            <LimitedChipItems
                items={chipItems}
                onDelete={handleRemoveValue}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                isTabExpanded={isExpanded}
            />
        </Flex>
    );
};

export default AppAndroidCategoryFilterResult;
